import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function RoleRoute({ allowedRoles }) {
  const { rol } = useAuth()
  return allowedRoles.includes(rol) ? <Outlet /> : <Navigate to="/dashboard" replace />
}
